import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getEmailTracker ({userId, threadId}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = []
    if (userId) query.push(`userMail[]=${userId}`)
    if (threadId) query.push(`threadId[]=${threadId}`)
    return instCred.get(`openmessages?${query.join('&')}`)
  },
  updateEmailTracker (email) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('openmessages/' + email.trackerId, email)
  },
  createEmailTracker (email) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('openmessages', email)
  },
  deleteEmailTracker (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('openmessages/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/EmailTracker/api.js